import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import MuiForm from 'components/MuiForm';

const propTypes = {
  formKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  schema: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

const MinorDetailsFormFields = ({formKey, schema, data, onChange}) => (
  <Wrapper className="minor-details-mui-fields">
    <MuiForm
      key={formKey}
      schema={schema}
      data={data}
      onChange={onChange}
      onSubmit={() => {}}
      title=""
      sub_title=""
      className="minor-details-mui-form"
      wrapperClassName="minor-details-mui-form-wrapper"
      updateSchema={(result) => result}
    />
  </Wrapper>
);

const Wrapper = styled.div`
  margin-bottom: 1rem;

  .minor-details-mui-form-wrapper,
  .minor-details-mui-form {
    height: auto !important;
    min-height: 0 !important;
  }

  .minor-details-mui-form-wrapper .footer,
  .minor-details-mui-form .footer {
    display: none !important;
  }

  .minor-details-mui-form-wrapper form {
    height: auto !important;
    min-height: 0 !important;
    display: block;
  }

  .input-container {
    margin-bottom: 1rem;
  }
`;

MinorDetailsFormFields.propTypes = propTypes;

export default MinorDetailsFormFields;
